import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getRanking(category: string): Promise<AxiosResponse<any, any>> {
    const encodedCategory = encodeURIComponent(category);
    return axiosInstance.get(`Evaluation/GetRanking/${encodedCategory}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
    });
}